import React from "react";

interface RCAConclusionSectionProps {
  conclusion: string;
  onChange: (value: string) => void;
  readOnly: boolean;
}

const RCAConclusionSection: React.FC<RCAConclusionSectionProps> = ({
  conclusion,
  onChange,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">
        J. Conclusion on Root Cause & Contributing Factors
      </h3>
      <div>
        <label className="block text-sm font-medium mb-1">Conclusion</label>
        <textarea
          value={conclusion}
          onChange={(e) => onChange(e.target.value)}
          className="w-full p-2 border rounded"
          rows={6}
          readOnly={readOnly}
          placeholder="Summary conclusion of root cause and all contributing factors identified"
        />
      </div>
    </div>
  );
};

export default RCAConclusionSection;
